module.exports = __webpack_public_path__ + "static/media/VaderPay_app.de25aa2f.svg";